import { Box, Tooltip, Typography } from '@mui/material';
import { MODO_PARTICIPACAO_ADVOGADO } from '@/dominio/ModoParticipacaoAdvogado';
import { computed, makeObservable } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import '../css/processo.css';
import ReactComponent from './ReactComponent';
class TableAdvogado extends ReactComponent {
    constructor(props) {
        super(props);

        makeObservable(this, {
            nome: computed,
            prefixoNome: computed,
            tooltip: computed,
            oabUf: computed,
            className: computed
        });
    }

    get nome() {
        return this.observableProps.advogado.nome;
    }

    get prefixoNome() {
        return this.observableProps.advogado.genero === 'F' ? 'Adv.ª:' : 'Adv.°:';
    }

    get tooltip() {
        let textoTooltipSessao = '';
        let textoTooltipVirtual = '';

        if (this.observableProps.advogado.modoParticipacao !== MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo) {
            if (this.observableProps.advogado.dataSolicitacaoSustentacao !== undefined) {
                textoTooltipSessao =
                    'Inscrito em ' +
                    moment(this.observableProps.advogado.dataSolicitacaoSustentacao, 'DD-MM-YYYY-HH-mm-ss').format(
                        'DD/MM/YYYY HH:mm:ss'
                    );
            } else {
                textoTooltipSessao = 'Data e hora da inscrição desconhecidas.';
            }
        }

        if (this.observableProps.advogado.modoParticipacao === MODO_PARTICIPACAO_ADVOGADO.VIRTUAL.codigo) {
            let dataHora =
                this.observableProps.advogado.dataSolicitacaoParticipacaoVirtual ||
                this.observableProps.advogado.dataSolicitacaoSustentacao ||
                undefined;
            if (dataHora) {
                textoTooltipVirtual =
                    'Pedido de participação virtual registrado em ' +
                    moment(dataHora, 'DD-MM-YYYY-HH-mm-ss').format('DD/MM/YYYY HH:mm:ss');
            } else {
                textoTooltipVirtual = 'Data e hora do registro do pedido de participação virtual desconhecidas.';
            }
        }

        return (
            <>
                <Typography>{textoTooltipSessao}</Typography>
                <Typography>{textoTooltipVirtual}</Typography>
            </>
        );
    }

    get oabUf() {
        const adv = this.observableProps.advogado;

        if (adv.regOAB) {
            if (adv.regOAB.letra) {
                return `${adv.regOAB.numero}-${adv.regOAB.letra}/${adv.regOAB.siglaUf}`;
            } else {
                return `${adv.regOAB.numero}/${adv.regOAB.siglaUf}`;
            }
        } else {
            return 'não informada';
        }
    }

    get className() {
        return this.observableProps.className ? this.observableProps.className : 'align';
    }

    render() {
        return (
            <Box
                component="div"
                sx={{ display: 'flex', alignItems: 'center' }}
            >
                <Tooltip
                    title={this.tooltip}
                    placement="top"
                    slotProps={{
                        popper: { style: { zIndex: '99999' } }
                    }}
                >
                    <div className={this.className}>
                        <Typography>
                            {this.prefixoNome} {this.nome} - OAB: {this.oabUf}
                        </Typography>
                    </div>
                </Tooltip>
            </Box>
        );
    }
}

export default inject('stores')(observer(TableAdvogado));
